import { createApp } from 'vue';
import HikeMapEmbed from './HikeMapEmbed.vue';
import { i18n } from '../../i18n';

if (document.querySelector('#hike-map-embed')) {
  const app = createApp(HikeMapEmbed);
  app.use(i18n);
  app.mount('#hike-map-embed');
}
